import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_arfo4zvzts: FaireBrandEntity = {
  token: "b_arfo4zvzts",
  type: "brand",
  name: "NCLA Beauty",
  avatarUrl:
    "https://cdn.faire.com/fastly/9039469e50ce82350237f8bfdf9aff1bb84e83bb68222c83ecd9b5c64447086d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/affdb7151feec78e7fa654841980cec1cc86c9ee061b9edaeb8b8ca62c519610.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/9039469e50ce82350237f8bfdf9aff1bb84e83bb68222c83ecd9b5c64447086d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/affdb7151feec78e7fa654841980cec1cc86c9ee061b9edaeb8b8ca62c519610.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 395,
  isTopShop: true,
  isInsider: true,
  description:
    "\nThis is NCLA Beauty. Welcome to our world! Here, you’ll discover a sensory paradise where clean beauty, natural ingredients, sublime textures, heavenly scents, colorful design and quirky individuality collide. \n\nOur mission is to create magical experiences through our skin and body products that truly delight the senses and deliver that ‘OMG’ moment. Your self-care is our priority!\n\nWhen you feel, touch, smell and apply our products, you’ll really understand what NCLA Beauty is all about. From our sweeter than sweet lip scrubs to our rich and decadent body butters – we serve up skin treats that will always make you want seconds. \n\nNCLA is created by two Los Angeles-based Asian-American sisters Elin & Anh-Thu Dannerstedt who are living their dream; conjuring up one-of-a-kind, feel-good products and reimagining beauty rituals for people all over the world. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:07.806Z",
    importedBy: "entity-db-cli",
  },
};
